/**
 * Native app bootstrap — runs once when the React app mounts.
 *
 * Configures status bar, splash screen, hardware back button, deep links.
 * On web this is a no-op.
 */
import { isNative, isAndroid } from './native';

let _booted = false;

export async function bootstrapNative() {
  if (_booted || !isNative()) return;
  _booted = true;

  try {
    // Status bar: dark style (light text) over our dark #0B0C10 header.
    const { StatusBar, Style } = await import('@capacitor/status-bar');
    await StatusBar.setStyle({ style: Style.Dark }).catch(() => {});
    if (isAndroid()) {
      await StatusBar.setBackgroundColor({ color: '#0B0C10' }).catch(() => {});
    }
  } catch { /* plugin missing on web */ }

  try {
    // Splash screen: hide as soon as React has painted Home.
    const { SplashScreen } = await import('@capacitor/splash-screen');
    await SplashScreen.hide().catch(() => {});
  } catch { /* ignore */ }

  try {
    // Hardware back button on Android: let the router handle navigation; exit
    // the app if there's nothing to pop.
    const { App } = await import('@capacitor/app');
    App.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) window.history.back();
      else App.exitApp();
    });
  } catch { /* ignore */ }
}
